import VistassistantMailFullView from "../VistassistantMailFullView";
import type { MailTab } from "./sidePanes";
import useLiveAssistantMail from "./useLiveAssistantMail";

/**
 * A mail in its tab: its thread, opened read-only.
 * The mail is read live from the list it was shown in (useLiveAssistantMail).
 */
const MailPane = ({ tab }: { tab: MailTab }) => {
    const mail = useLiveAssistantMail(tab.listId, tab.mail);

    return <VistassistantMailFullView listId={tab.listId} mail={mail} />;
};

export default MailPane;
